// 공통 비교 유틸

export const numCmp = (a?: number | null, b?: number | null) =>
    (a ?? Number.NEGATIVE_INFINITY) - (b ?? Number.NEGATIVE_INFINITY);

export const dateCmp = (a?: string | null, b?: string | null) =>
    (Date.parse(a ?? '') || 0) - (Date.parse(b ?? '') || 0);

export const strCmp = (a?: string | null, b?: string | null) =>
    (a ?? '').localeCompare(b ?? '', undefined, { sensitivity: 'base' });
